// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"750":"c294b31c93738c532f52","864":"47636d13eb417f72c5fc"}[chunkId] + ".css";
};